import axios from "@/api/axiosAuthRequired.js"
const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL

export const getAvailableJobs = async () => {
  try {
    const url = `${PROGUIDES_WEB_URL}functions/careers/get_available_jobs.php`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const applyJob = async body => {
  try {
    const url = `${PROGUIDES_WEB_URL}functions/careers/apply_for_job.php`
    const res = await axios.post(url, body)
    return res.data
  } catch (error) {
    console.error(error)
    return error.data
  }
}



// WEBPACK FOOTER //
// ./src/api/jobs.js